import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Skeleton } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";

import api from "../../../BrandOnBoarding/api";
import ErrorView from "../../../Component/ErrorView/ErrorView";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import { AuthContext } from "../../../context/auth-context";
import ProductItem from "../../CategoryDiscovery/Products/ProductItem";
import { DiscoveryContext } from "../discovery-context";
import MUICard from "./../../../Component/UI/MUICard/MUICard";
import useCustomerReviews from "./../../CategoryDiscovery/CustomerReviews/useCustomerReviews";
import useClassifyProduct from "./../../CategoryDiscovery/Products/useClassifyProduct";
import CompetitorItem from "./CompetitorItem";
import classes from "./Competitors.module.css";

export default function Competitors({ category, brand }) {
  const [error, setError] = useState();
  const containerRef = useRef(null);
  const { user } = useContext(AuthContext);
  const { license_status } = user?.customer;

  const abortControllersRef = useRef([]);
  const discoveryCtx = useContext(DiscoveryContext);
  const { classifiedProducts } = useClassifyProduct();
  const { loading: reviewsLoading, reviews } = useCustomerReviews();

  let competitors = discoveryCtx.competitors
    .slice(discoveryCtx.type == "category" ? 0 : 1, 4)
    .map((c) => c.name);

  useEffect(() => {
    if (discoveryCtx.brand_scores.length > 0) return;
    getBrandIndexScores();

    return () => {
      //abortControllersRef.current.forEach((controller) => controller.abort());
    };
  }, [discoveryCtx.brand_scores.length, competitors.length]);

  useEffect(() => {
    if (discoveryCtx.abort_launch) {
      abortControllersRef.current.forEach((controller) => controller.abort());
    }
  }, [discoveryCtx.abort_launch]);

  function createPromise(product, index) {
    const controller = new AbortController();
    abortControllersRef.current[index] = controller;

    let sentimentCount = 5;
    const isWebSearch =
      discoveryCtx.llm === "gpt-4o-web-search" ||
      discoveryCtx.llm === "gpt-4o-agent-web-search" ||
      discoveryCtx.llm === "GeminiV25Search" ||
      discoveryCtx.llm === "Claude3Search" ||
      discoveryCtx.llm === "gpt-5-search-enabled"

    if (
      discoveryCtx.type === "category" ||
      discoveryCtx.llm === "deepseek_together"
    ) {
      sentimentCount = 1;
    } else if (isWebSearch) {
      sentimentCount = license_status === "Paid" ? 5 : 1;
      if (discoveryCtx.llm === "GeminiV25Search" || discoveryCtx.llm === "Claude3Search" || discoveryCtx.llm === "gpt-5-search-enabled") {
        sentimentCount = 1;
      }
    }

    const payload = {
      llm: discoveryCtx.llm,
      category: category,
      count: 5,
      brand: discoveryCtx.type === "brand" ? "companies" : "products",
      persona: "General Profile",
      return_meta: true,
      rank_exec_count:
        discoveryCtx.type === "category" ||
          discoveryCtx.llm === "deepseek_together"
          ? 1
          : 5,
      sentiment_exec_count: sentimentCount,
      market: discoveryCtx.market,
      product: product,
      language_id: discoveryCtx.language == "it" ? 2 : 1,
      customer_id: user.customer_id,
    };
    const configs = {
      signal: controller.signal,
    };
    return api.post(
      "/metrics/v4/get-brand-index-score?score_type_flag=sentiment",
      payload,
      configs
    );
  }

  async function getBrandIndexScores() {
    setError(null);
    abortControllersRef.current = [];

    try {
      const promiseArr = competitors.map((competitor, index) => {
        return createPromise(competitor, index);
      });

      promiseArr.forEach((promise, index) => {
        promise
          .then((result) => {
            const entity = result.data.data[0];
            const sources = [
              ...Object.keys(result?.data?.sources?.sentiment || {}),
            ];
            discoveryCtx.updateSources(sources);
            discoveryCtx.updateBrandScores({
              data: {
                name: entity.name,
                favorability: entity.score,
                extras: result.data.extras,
              },
              index: index + (discoveryCtx.type === "category" ? 0 : 1),
            });
          })
          .catch((error) => {
            discoveryCtx.updateBrandScores({
              data: { error: error?.message },
              index: index + (discoveryCtx.type === "category" ? 0 : 1),
            });
          });
      });
    } catch (error) {
      setError(error.message);
    }
  }

  async function BrandIndexRetryHandler(index) {
    console.log(competitors[index]);
    discoveryCtx.updateBrandScores({ data: null, index: index + 1 });
    const promiseArr = [];
    promiseArr.push(createPromise(competitors[index]));

    try {
      const [response] = await Promise.all(promiseArr);
      const entity = response.data.data[0];
      discoveryCtx.updateBrandScores({
        data: {
          name: entity.name,
          favorability: entity.score,
          extras: response.data.extras,
        },
        index: index + 1,
      });
    } catch (error) {
      discoveryCtx.updateBrandScores({
        data: { error: "someting went wrong" },
        index: index + 1,
      });
    }
  }

  let brandData = discoveryCtx.brand_scores;

  const scroll = (direction) => {
    if (containerRef.current) {
      const scrollAmount = 480;
      const newScrollPosition =
        direction === "next"
          ? containerRef.current.scrollLeft + scrollAmount
          : containerRef.current.scrollLeft - scrollAmount;
      containerRef.current.scrollTo({
        left: newScrollPosition,
        behavior: "smooth",
      });
    }
  };
  let brandDataCompetitors = brandData.slice(1);
  const highestFavorability = Math.max(...brandDataCompetitors.map((item) => item?.favorability ?? 0));
  const highestIndex = brandDataCompetitors.findIndex(
    (item) => item?.favorability === highestFavorability
  );


  return (
    <MUICard
      title={
        discoveryCtx.type === "category" ? "Products" : "Competitor Analysis"
      }
      variant="elevated"
      elevation={0}
      className={classes.card}
      titleClassName={classes.title}
      width={"100%"}
    >
      {discoveryCtx.type === "category" && (
        <>
          <MUIIconButton
            className={`${classes.chevron_btn} ${classes.prev}`}
            onClick={() => scroll("prev")}
          >
            <ArrowBackIosNewIcon />
          </MUIIconButton>
          <MUIIconButton
            className={`${classes.chevron_btn} ${classes.next}`}
            onClick={() => scroll("next")}
          >
            <ArrowForwardIosIcon />
          </MUIIconButton>
        </>
      )}
      <div
        ref={containerRef}
        style={{ position: "relative" }}
        className={
          discoveryCtx.type === "category"
            ? classes.products_container
            : classes.container
        }
      >
        {!error &&
          competitors.map((competitor, index) => {
            return (
              <React.Fragment key={index}>
                {discoveryCtx.type === "category" ? (
                  <ProductItem
                    classifiedProducts={classifiedProducts}
                    index={index}
                    name={competitor}
                    brandIndex={
                      brandData[
                      index + (discoveryCtx.type === "category" ? 0 : 1)
                      ]
                    }
                    reviews={reviews[index]}
                    reviewLoading={reviewsLoading}
                  />
                ) : (
                  <React.Fragment key={index}>
                    {brandData[index + 1] ? (
                      <CompetitorItem
                        competitor={competitor}
                        brandIndex={brandData[index + 1]}
                        brand={brand}
                        index={index}
                        isHighestFavorability={(index + 1) === (highestIndex + 1)}
                        onRetry={BrandIndexRetryHandler}
                      />
                    ) : (
                      <Skeleton
                        variant="rounded"
                        style={{
                          flexGrow: 1,
                          height: 220,
                          flexBasis: "calc(50% - 12.5px)",
                        }}
                      />
                    )}
                    {index < competitors.length - 1 && (
                      <div className={classes.separator}></div>
                    )}
                  </React.Fragment>
                )}
              </React.Fragment>
            );
          })}
        {error && (
          <div className={classes.error}>
            <ErrorView
              title={"Error fetching competitor analysis"}
              message={error}
              retry
              onRetry={() => getBrandIndexScores()}
            />
          </div>
        )}
      </div>
    </MUICard>
  );
}
